import { Badge } from '@/components/ui';
import { STATUS_COLORS } from '../utils/qrCodeConstants';

interface QrCodeStatusBadgeProps {
  status: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function QrCodeStatusBadge({ status, size = 'sm' }: QrCodeStatusBadgeProps) {
  return (
    <Badge color={STATUS_COLORS[status] || 'gray'} size={size} variant="light">
      {status}
    </Badge>
  );
}
